import React from 'react';

const Icon = ({ size = '48', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" fill="none" {...other}>
            <g clipPath="url(#a)" stroke="black">
                <path
                    d="M18.537 35.36a2.225 2.225 0 0 0 2.225 2.107h6.41c1.194 0 2.17-.934 2.23-2.126.168-3.357.548-7.657 2.63-9.69 2.048-1.994 3.193-4.673 3.186-7.462 0-5.897-5.041-10.695-11.24-10.695-6.216 0-11.153 4.632-11.238 10.545a10.176 10.176 0 0 0 .782 4.086 10.59 10.59 0 0 0 2.368 3.49c2.08 2.05 2.462 6.376 2.647 9.744Zm8.439 2.855a2.997 2.997 0 1 1-5.995 0m-2.997-4.87h11.989"
                    strokeWidth="2.248"
                />

                <path
                    d="M8.992 16.484H5.995m32.97-.437h2.997m-31.91-4.497-2.12-2.119m29.974 1.68 2.119-2.12M10.052 20.98l-2.12 2.12m29.974-2.557 2.119 2.12"
                    strokeWidth="2.248"
                    strokeLinecap="round"
                />

                <path
                    d="M26.227 23.23v8.992H22.48V23.23h3.747Zm1.498-2.999a1.5 1.5 0 0 1 0 2.998h-1.499v-1.498a1.5 1.5 0 0 1 1.5-1.5Zm-6.744 0a1.5 1.5 0 0 0 0 2.998h1.5v-1.498a1.5 1.5 0 0 0-1.5-1.5Z"
                    strokeWidth="1.499"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M0 0h47.957v47.957H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
